import React from "react";
import { useSelector } from "react-redux";
import AccountsPage from "../../components/dashboard/AccountsPage";
import {
  deleteCustomerAccount,
  getCustomers,
  updateCustomerAccount,
} from "../../redux/actions/userActions";

// Clients create their account themselves, so none can be added here
function AdminCustomers() {
  const { customers } = useSelector((state) => state.users);

  return (
    <AccountsPage
      title="Clients"
      lead="Les comptes créés par les clients sur Platform98."
      accounts={customers}
      load={getCustomers}
      update={updateCustomerAccount}
      remove={deleteCustomerAccount}
      emptyText="Aucun client pour le moment."
    />
  );
}

export default AdminCustomers;
